module.exports = __webpack_public_path__ + "img/art5-img1.2df675f2.jpeg";